/**
 * 
 */
export default class RestApi {
  auth = {
    login: (data) => $app.api.post([ 'auth/login', ]).data(data).with('accesses'),
    info: () => $app.api.get([ 'auth/info', ]),

  }
  
  files = {
    create: (data) => {
      const formData = new FormData()
      $n.each(data, (value, name) => {
        formData.append(name, value)
      })
      return $app.api.post([ 'files', ]).data(formData).config({ headers: { 'Content-Type': 'multipart/form-data', }, })
    },
  }

  formpm = {
    get: (id) => $app.api.get([ 'form-pm-categories*', id, ]),
    getAll: () => $app.api.get([ 'form-pm-categories', ]),
    edit: (id, data) => $app.api.patch([ 'form-pm-categories*', id, ]).data(data),
    create: (data) => $app.api.post([ 'form-pm-categories', ]).data(data),
    delete: (id) => $app.api.delete([ 'form-pm-categories*', id, ]),
  }
  formpmsections = {
    get: (id) => $app.api.get([ 'form-pm-sections*/one', id, ]),
    getAll: (id) => $app.api.get([ 'form-pm-sections*', id, ]),
    edit: (id, data) => $app.api.patch([ 'form-pm-sections*', id, ]).data(data),
    create: (data) => $app.api.post([ 'form-pm-sections', ]).data(data),
    delete: (id) => $app.api.delete([ 'form-pm-sections*', id, ]),
  }
  formpmquestions = {
    get: (id) => $app.api.get([ 'form-pm-questions*/one', id, ]),
    getAll: (id) => $app.api.get([ 'form-pm-questions*', id, ]),
    edit: (id, data) => $app.api.patch([ 'form-pm-questions*', id, ]).data(data),
    create: (data) => $app.api.post([ 'form-pm-questions', ]).data(data),
    delete: (id) => $app.api.delete([ 'form-pm-questions*', id, ]),
  }
  formpmresults = {
    get: (id) => $app.api.get([ 'form-pm-results*/one', id, ]),
    getLast: (id) => $app.api.get([ 'form-pm-results/last-target*', id, ]),
    getAll: () => $app.api.get([ 'form-pm-results', ]),
    getAnswers: (id) => $app.api.get([ 'form-pm-results*/answers', id, ]),
    getStatsExcel: (data) => $app.api.post([ 'form-pm-results/excel', ]).data(data),
    edit: (id, data) => $app.api.patch([ 'form-pm-results*', id, ]).data(data),
    create: (data) => $app.api.post([ 'form-pm-results', ]).data(data),
    save: (data) => $app.api.post([ 'form-pm-results/answers', ]).data(data),
    allowEdit: (id) => $app.api.post([ 'form-pm-results*/allow-edit', id, ]),
    delete: (id) => $app.api.delete([ 'form-pm-results*', id, ]),
    avg: (data) => $app.api.post([ 'kln/avg-pm/results', ]).data(data),
  }
  
  categories = {
    get: (id) => $app.api.get([ 'categories*', id, ]),
    getAll: (id) => $app.api.get([ 'admin/categories*', id, ]),
    edit: (id, data) => $app.api.patch([ 'categories*', id, ]).data(data),
    getSub: (id) => $app.api.get([ 'admin/categories*/subcategories', id, ]),
    getDeleted: () => $app.api.get([ 'admin/categories/deleted', ]),
    create: (data) => $app.api.post([ 'categories', ]).data(data),
    delete: (id) => $app.api.delete([ 'categories*', id, ]),
    restore: (id) => $app.api.post([ 'categories*/restore', id, ]),
  }

  timercategories = {
    get: (id) => $app.api.get([ 'timer-categories*', id, ]),
    getAll: (id) => $app.api.get([ 'admin/timer-categories*', id, ]),
    edit: (id, data) => $app.api.patch([ 'timer-categories*', id, ]).data(data),
    create: (data) => $app.api.post([ 'timer-categories', ]).data(data),
    delete: (id) => $app.api.delete([ 'timer-categories*', id, ]),
  }

  timerquizzes = {
    getAll: (categoryId) => $app.api.get([ 'kln/admin/timer-categories*/timer-quizzes', categoryId, ]),
    get: (id) => $app.api.get([ 'kln/timer-quizzes*', id, ]),
    getByCategory: (categoryId) => $app.api.get([ 'kln/timer-categories*/timer-quizzes', categoryId, ]),
    edit: (id, data) => $app.api.patch([ 'kln/timer-quizzes*', id, ]).data(data),
    create: (data) => $app.api.post([ 'kln/timer-quizzes', ]).data(data),
    delete: (id) => $app.api.delete([ 'kln/timer-quizzes*', id, ]),
  }

  timerquestions = {
    get: (id) => $app.api.get([ 'kln/timer-quizzes*/timer-questions', id, ]),
    getOne: (id) => $app.api.get([ 'kln/timer-questions*', id, ]),
    getByQuiz: (quizId) => $app.api.get([ 'kln/timer-quizzes*/timer-questions', quizId, ]),
    create: (data) => $app.api.post([ 'kln/timer-questions', ]).data(data),
    edit: (id, data) => $app.api.patch([ 'kln/timer-questions*', id, ]).data(data),
    delete: (id) => $app.api.delete([ 'kln/timer-questions*', id, ]),
  }
  theorymanager = {
    get: (id) => $app.api.get([ 'kln/manager-categories*', id, ]),
    edit: (id, data) => $app.api.patch([ 'kln/manager-categories*', id, ]).data(data),
  }
  timerresults = {
    get: (id) => $app.api.get([ 'kln/timer-results*', id, ] ),
    excel: (data) => $app.api.post([ 'timer/excel/select', ]).data(data),
    patch: (id, data) => $app.api.patch([ 'kln/timer-results*', id, ]).data(data),
    getAvg: (data) => $app.api.post([ 'kln/avg-points/timer-results', ]).data(data),
    delete: (id) => $app.api.delete([ 'kln/timer-results*', id, ]),
    makeFinish: (id) => $app.api.post([ 'kln/timer-results*/finish', id, ]),
  }
  timeranswers = {
    save: (resultId, quizId, data) => $app.api.post([ 'kln/timer-results*/timer-quizzes*/timer-answers', resultId, quizId, ]).data(data),
  }

  quizzes = {
    getAll: (categoryId) => $app.api.get([ 'kln/admin/categories*/quizzes', categoryId, ]),
    get: (id) => $app.api.get([ 'kln/quizzes*', id, ]),
    getByCategory: (categoryId) => $app.api.get([ 'kln/categories*/quizzes', categoryId, ]),
    edit: (id, data) => $app.api.patch([ 'kln/quizzes*', id, ]).data(data),
    create: (data) => $app.api.post([ 'kln/quizzes', ]).data(data),
    delete: (id) => $app.api.delete([ 'kln/quizzes*', id, ]),
  }
  branches = {
    get: (id) => $app.api.get([ 'branches*', id, ]),
    getAll: () => $app.api.get([ 'branches', ]),
    edit: (id, data) => $app.api.patch([ 'branches*', id, ]).data(data),
  }

  hrSpecialistBranches = {
    getSpecialists: () => $app.api.get([ 'hr-specialists', ]),
    get: (userId) => $app.api.get([ 'hr-specialists*', userId, 'branches', ]),
    sync: (userId, data) => $app.api.put([ 'hr-specialists*', userId, 'branches', ]).data(data),
    getMine: () => $app.api.get([ 'my/hr-branches', ]),
  }

  meCommand = {
    getUsers: (data) => $app.api.post([ 'kln/users-for-plan-filling', ]).data(data),
    makeDoc: (data) => $app.api.post([ 'kln/make-me-command', ]).data(data),
  }

  questions = {
    get: (id) => $app.api.get([ 'kln/quizzes*/questions', id, ]),
    getOne: (id) => $app.api.get([ 'kln/questions*', id, ]),
    getByQuiz: (quizId) => $app.api.get([ 'kln/quizzes*/questions', quizId, ]),
    create: (data) => $app.api.post([ 'kln/questions', ]).data(data),
    edit: (id, data) => $app.api.patch([ 'kln/questions*', id, ]).data(data),
    delete: (id) => $app.api.delete([ 'kln/questions*', id, ]),
  }


  answers = {
    save: (resultId, quizId, data) => $app.api.post([ 'kln/results*/quizzes*/answers', resultId, quizId, ]).data(data),
  }
  products = {
    get: (id) => $app.api.get([ 'products*', id, ]),
    create: (data) => $app.api.post([ 'products', ]).data(data),
    edit: (id, data) => $app.api.patch([ 'products*', id, ]).data(data),
    delete: (id) => $app.api.delete([ 'products*', id, ]),
    params: {
      get: (id) => $app.api.get([ 'parameters*', id, ]),
      create: (pId, data) => $app.api.post([ 'products*/parameters', pId, ]).data(data),
      edit: (id, data) => $app.api.patch([ 'parameters*', id, ]).data(data),
      delete: (id) => $app.api.delete([ 'parameters*', id, ]),
    },
    comments: {
      get: (id) => $app.api.get([ 'comments*', id, ]),
      delete: (id) => $app.api.delete([ 'comments*', id, ]),
      edit: (id, data) => $app.api.patch([ 'comments*', id, ]).data(data),
    },
  }
  
  orders = {
    get: (id) => $app.api.get([ 'orders*', id, ]),
    edit: (id, data) => $app.api.patch([ 'orders*', id, ]).data(data),
    editMulti: ( data) => $app.api.patch([ 'orders-multi-edit', ]).data(data),
    excelStats: ( data) => $app.api.post([ 'orders/excel-stats', ]).data(data),
  }
  
  news = {
    get: (id) => $app.api.get([ 'news*', id, ]),
    create: (data) => $app.api.post([ 'news', ]).data(data),
    edit: (id, data) => $app.api.patch([ 'news*', id, ]).data(data),
    delete: (id) => $app.api.delete([ 'news*', id, ]),
  }
  
  schedules = {
    get: (id) => $app.api.get([ 'schedules*', id, ]),
    useLastTimeWindows: (id) => $app.api.post([ 'schedules*/use-last-time-windows', id, ]),
    getUsers: (id, data) => $app.api.post([ 'schedules*/get-users', id, ]).data(data),
    edit: (id, data) => $app.api.patch([ 'schedules*', id, ]).data(data),
    editTime: (id, data) => $app.api.patch([ 'schedules*/edit-time', id, ]).data(data),
    getEmployeeContext: (id, data) => $app.api.post([ 'schedules*/employee-context', id, ]).data(data),
    sentToTimeTracker: (id) => $app.api.post([ 'schedules*/send-time-tracker', id, ]),
    accept: (id) => $app.api.patch([ 'schedules*/confirm', id, ]),
    decline: (id) => $app.api.patch([ 'schedules*/decline', id, ]),
    create: (data) => $app.api.post([ 'schedules', ]).data(data),
    getPdf: (id, data) => $app.api.post([ 'schedules*/schedule-pdf', id, ]).data(data),
    getFinancePdf: (id, data) => $app.api.post([ 'schedules*/finance-pdf', id, ]).data(data),
    getFinanceDailyPdf: (id, data) => $app.api.post([ 'schedules*/finance-daily-pdf', id, ]).data(data),
    getHealthPdf: (id, data) => $app.api.post([ 'schedules*/health-pdf', id, ]).data(data),
    getFoodPdf: (id, data) => $app.api.post([ 'schedules*/food-pdf', id, ]).data(data),
    getManagerPdf: (id, data) => $app.api.post([ 'schedules*/manager-pdf', id, ]).data(data),
    getWeekPdf: (id, data) => $app.api.post([ 'schedules*/week-pdf', id, ]).data(data),
    getWeekDayPdf: (id, data) => $app.api.post([ 'schedules*/week-day-pdf', id, ]).data(data),
  }
  stats = {
    getStats: (data) => $app.api.post([ 'schedules/stats/gcph', ]).data(data),
    getStatsExcel: (data) => $app.api.post([ 'schedules/gcph/excel', ]).data(data),
    getDirectors: () => $app.api.get([ 'schedules/gcph/directors', ]),
    getDirectorBranches: (id) => $app.api.get([ 'director-branches*', id, ]),
    save: (data) => $app.api.post([ 'director-branches', ]).data(data),
    delete: (id) => $app.api.delete([ 'director-branches*', id, ]),

  }

  wantedTimes = {
    get: (id) => $app.api.get([ 'wanted-times*', id, ]),
    getSchedule: () => $app.api.get([ 'wanted-times-schedule', ]),
    create: (data) => $app.api.post([ 'wanted-times-by-admin', ]).data(data),
    revert: (data) => $app.api.post([ 'wanted-times-by-admin-revert', ]).data(data),
    revertMass: (data) => $app.api.post([ 'wanted-times-by-admin-revert-mass', ]).data(data),
    makeWeekends: (data) => $app.api.post([ 'wanted-times-made-weekends', ]).data(data),
    makeFullTime: (data) => $app.api.post([ 'wanted-times-made-full-time', ]).data(data),
    decline: (id, data) => $app.api.post([ 'wanted-times*/decline', id, ]).data(data),
    confirm: (id) => $app.api.post([ 'wanted-times*/confirm', id, ]),
    confirmByAdmin: (id) => $app.api.post([ 'wanted-times*/confirmByAdmin', id, ]),
  }

  achievements = {
    get: (id) => $app.api.get([ 'achievements*', id, ]),
    edit: (id, data) => $app.api.patch([ 'achievements*', id, ]).data(data),
    delete: (id) => $app.api.delete([ 'achievements*', id, ]),
    create: (data) => $app.api.post([ 'achievements', ]).data(data),
    give: (id, data) => $app.api.post([ 'achievements*/users', id, ]).data(data),
  }

  transactions = {
    get: (id) => $app.api.get([ 'transactions*', id, ]),
  }

  notifications = {
    get: () => $app.api.get([ 'admin/notifications', ]),
  }
  
  results = {
    get: (id) => $app.api.get([ 'kln/results*', id, ]),
    getAvg: (data) => $app.api.post([ 'kln/avg-points/results', ]).data(data),
    excel: (data) => $app.api.post([ 'kln/excel/select', ]).data(data),
    delete: (id) => $app.api.delete([ 'kln/results*', id, ]),
    makeFinish: (id) => $app.api.post([ 'kln/results*/finish', id, ]),
    patch: (id, data) => $app.api.patch([ 'kln/results*', id, ]).data(data),
  }
  
  file = {
    getQuizIcons: () => $app.api.get([ 'quiz-icons', ]),
    edit: (id, data) => $app.api.patch([ 'files*', id, ]).data(data),
    delete: (id) => $app.api.delete([ 'files*', id, ]),
    create: (data) => {
      const formData = new FormData()
      $n.each(data, (value, name) => {
        formData.append(name, value)
      })
      return $app.api.post([ 'files', ]).data(formData).config({ headers: { 'Content-Type': 'multipart/form-data', }, })
    },
    getDocs: (userId) => $app.api.get([ 'files/users*', userId, ]),
  }
  
  users = {
    get: (id) => $app.api.get([ 'users*', id, ]),
    createStaj: (data) => $app.api.post([ 'users-stajor', ]).data(data),
    getAll: () => $app.api.get([ 'all-users', ]),
    getAllBranch: (id) => $app.api.get([ 'all-users*', id, ]),
    getResultsAll: () => $app.api.get([ 'all-results-users', ]),
    edit: (id, data) => $app.api.patch([ 'users*', id, ]).data(data),
    getOrders: (id) => $app.api.get([ 'users*/orders', id, ]),
    getResults: (id) => $app.api.get([ 'users*/results', id, ]),
    getUserAchievements: (id) => $app.api.get([ 'users*/achievements', id, ]),
    getTimer: () => $app.api.get([ 'timer-users', ]),
    getDuplicates: (id) => $app.api.get([ 'users*/duplicates', id, ]),
    delete: (id) => $app.api.delete([ 'users*', id, ]),
  }
  
  accesses = {
    get: () => $app.api.get([ 'auth/accesses', ]),   
    give: (userId, data) => $app.api.post([ 'users*/give-access', userId, ]).data(data),
  }

  library = {
    get: (id) => $app.api.get([ 'library*', id, ]),
    getCategories: (id) => $app.api.get([ 'library-categories*', id, ]),
    create: (data) => $app.api.post([ 'library', ]).data(data),
    createCategory: (data) => $app.api.post([ 'library-categories', ]).data(data),
    edit: (id, data) => $app.api.patch([ 'library*', id, ]).data(data),
    editCategory: (id, data) => $app.api.patch([ 'library-categories*', id, ]).data(data),
    delete: (id) => $app.api.delete([ 'library*', id, ]),
    deleteCategory: (id) => $app.api.delete([ 'library-categories*', id, ]),
  }

  biottests = {
    getOne: (id) => $app.api.get([ 'biot-tests*', id, ]),
    getAll: () => $app.api.get([ 'biot-tests', ]),
    create: (data) => $app.api.post([ 'biot-tests', ]).data(data),
    edit: (id, data) => $app.api.patch([ 'biot-tests*', id, ]).data(data),
    delete: (id) => $app.api.delete([ 'biot-tests*', id, ]),
  }
  biotquestion = {
    getByTest: (id) => $app.api.get([ 'biot-questions*', id, ]),
    getOne: (id) => $app.api.get([ 'one/biot-questions*', id, ]),
    create: (data) => $app.api.post([ 'biot-questions', ]).data(data),
    edit: (id, data) => $app.api.patch([ 'biot-questions*', id, ]).data(data),
    delete: (id) => $app.api.delete([ 'biot-questions*', id, ]),
  }
  biotanswers = {
    getByTest: (id) => $app.api.get([ 'biot-answers*', id, ]),
    getOne: (id) => $app.api.get([ 'one/biot-answers*', id, ]),
    create: (data) => $app.api.post([ 'biot-answers', ]).data(data),
    edit: (id, data) => $app.api.patch([ 'biot-answers*', id, ]).data(data),
    delete: (id) => $app.api.delete([ 'biot-answers*', id, ]),
  }
  biotresults = {
    getAll: () => $app.api.get([ 'biot-results', ]),
    delete: (id) => $app.api.delete([ 'biot-results*', id, ]),
  }
  voices = {
    getStats: (data) => $app.api.post([ 'voice-kz-stats', ]).data(data),
    importVoice: (data) => $app.api.post([ 'voice-kz-stats-import', ]).data(data),
  }
  analyticBranchData = {
    create: (branchId, data) => $app.api.post([ 'analytic/branches*/branch-data', branchId, ]).data(data),
    get: (branchId, id) => $app.api.get([ 'analytic/branches*/branch-data*', branchId, id, ]),
    getAll: () => $app.api.get([ 'analytic/branch-data-all', ]),
    edit: (branchId, id, data) => $app.api.patch([ 'analytic/branches*/branch-data*', branchId, id, ]).data(data),
  }
  hrsobes = {
    getByRating: (data) => $app.api.post([ 'hr-sobes-by-rating', ]).data(data),
    hiredScoring: (data) => $app.api.post([ 'hr-sobes-hired-with-scoring', ]).data(data),
    hiredWithRating: (data) => $app.api.post([ 'hr-sobes-hired-with-rating', ]).data(data),
    hiredWithInterviewRating: (data) => $app.api.post([ 'hr-sobes-hired-with-interview-rating', ]).data(data),
    invitedScoring: (data) => $app.api.post([ 'hr-sobes-invited-with-scoring', ]).data(data),
    invitedWithRating: (data) => $app.api.post([ 'hr-sobes-invited-with-rating', ]).data(data),
    invitedWithInterviewRating: (data) => $app.api.post([ 'hr-sobes-invited-with-interview-rating', ]).data(data),
    getByChatbotV2: (data) => $app.api.post([ 'hr-sobes-stats-chat-bot-v2', ]).data(data),
    hiredTotal: (data) => $app.api.post([ 'hr-sobes-hired-total', ]).data(data),
    invitedTotal: (data) => $app.api.post([ 'hr-sobes-invited-total', ]).data(data),
    getStatsTotal: (data) => $app.api.post([ 'hr-sobes-stats-total', ]).data(data),
    vacancies: (data) => $app.api.post([ 'hr-sobes-vacancies', ]).data(data),
    cities: (data) => $app.api.post([ 'hr-sobes-cities', ]).data(data),
    managers: (data) => $app.api.post([ 'hr-sobes-managers', ]).data(data),
    hireMetrics: (data) => $app.api.post([ 'hr-sobes-hire-metrics', ]).data(data),
    statsByUsV2: (data) => $app.api.post([ 'hr-sobes-stats-by-us-v2', ]).data(data),
    statsByManagers: (data) => $app.api.post([ 'hr-sobes-stats-by-managers', ]).data(data),
  }
}
